import './libs/stickyfill.es6';

//https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

// polyfill for position:sticky CSS rule (hello IE)
new Stickyfill.Sticky(document.getElementById('sidebar'));

if (iOS) {
    // force polyfill on ios system - they have buggy sticky CSS
    Stickyfill.forceSticky()
}
